import SparePartList from '@/components/SparePart/SparePartList'
import SparePartForm from '@/components/SparePart/SparePartForm'
import SparePartDetail from '@/components/SparePart/SparePartDetail'

let SparePartRouter = [{
  path: '/spare_part',
  name: 'SparePartList',
  component: SparePartList,
  meta: {
    title: 'Pièces de rechange',
    requiresAuth: true,
    authorizations: ['spare-part_index', 'desktop_access']
  }
}, {
  path: '/spare_part/new',
  name: 'SparePartNew',
  component: SparePartForm,
  meta: {
    title: 'Nouvelle pièce de rechange',
    requiresAuth: true,
    authorizations: ['spare-part_new', 'desktop_access']
  }
}, {
  path: '/spare_part/:id/edit',
  name: 'SparePartEdit',
  component: SparePartForm,
  meta: {
    title: 'Modifier une pièce de rechange',
    requiresAuth: true,
    authorizations: ['spare-part_edit', 'desktop_access']
  }
}, {
  path: '/spare_part/:id',
  name: 'SparePartDetail',
  component: SparePartDetail,
  meta: {
    title: 'Fiche pièce de rechange',
    requiresAuth: true,
    authorizations: ['spare-part_show', 'desktop_access']
  }
}]

export default SparePartRouter



// WEBPACK FOOTER //
// ./src/components/SparePart/router.js